import { ISkill } from "types/Skills.type";
import { ICorporateValues } from "./CorporateValue.type";
import { ICertificate } from "./ICertificate";
import { IUser } from "./User.types";

export enum EMessageTabs {
  TEXT = "TEXT",
  MAGAZINE = "MAGAZINE",
  CAPSULES = "CAPSULES",
  RECOGNITION = "RECOGNITION"
}

export enum EMessageType {
  TEXT = "TEXT",
  MAGAZINE = "MAGAZINE",
  CAPSULES = "CAPSULES",
  RECOGNITION = "RECOGNITION",
  POLL = "POLL",
  ENDORSEMENT = "ENDORSEMENT",
  BIRTHDAY = "BIRTHDAY",
  ANNIVERSARY = "ANNIVERSARY",
  NEW_USERS = "NEW_USERS",
  CORPORATE_VALUE = "CORPORATE_VALUE",
  CERTIFICATE = "CERTIFICATE",
  BUY_SELL = "BUY_SELL",
  MESSAGES = "MESSAGES",
  BENEFIT = "BENEFIT",
  ALL = "all"
}

export interface IPollAnswer {
  id: number;
  text: string;
  votes: number;
}

export interface IPollAnswers {
  user: string;
  index: number;
}

export interface IMessageComment {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  text?: string;
  createdBy?: IUser;
  reactions?: IMessageReaction[];
  edited?: boolean;
}

export interface IMessageReaction {
  emoji: "like" | "love" | "haha" | "wow" | "sad" | "angry";
  user: string;
  reactionUser?: IUser;
}

export interface IMessage {
  id: string;
  isVoted?: boolean;
  createdAt: Date;
  updatedAt: Date;
  type: EMessageType;
  text?: string;
  answers?: IPollAnswers[];
  answer: IPollAnswer[];
  createdBy?: IUser;
  ownerUser?: IUser;
  ownerUserId?: string;
  question?: string;
  questionOptions?: string[];
  comments: IMessageComment[];
  reactions: IMessageReaction[];
  edited?: boolean;
  seeingBy?: IUser[];
  skill?: ISkill;
  thumbnail?: string;
  newUsers?: IUser[];
  userWhoGivesCorporateValue?: IUser;
  corporateValue?: ICorporateValues;
  tags?: string[];
  timesSeen?: number;
  usersInMessage?: IUser[];
  certificate?: ICertificate;
  sourceMessageId?: string;
  sourceMessageType?: EMessageType;
  linkUrl?: string;
  previewTitle?: string;
  previewDescription?: string;
  isAutoGenerated?: boolean;
  uniqueViewsCount?: number;
  viewedByMe?: boolean;
}
